<template>
  <div>
    <h6 style="margin: 0px !important">{{ CARIKART_BAKIYE }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ PUANBAK }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      CARIKART_BAKIYE: 0.0,
      PUANBAK: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.CARIKART_BAKIYE = this.currencyFormatter(
        this.params.data.CARIKART_BAKIYE,
        "₺"
      );
      this.PUANBAK = this.currencyFormatter(this.params.data.PUANBAK, " ");
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var parfloat = parseFloat(currency);
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
